import { StarParticles } from './ConnexionParticles'
import { useTheme } from '../../theme'
import { avecAlpha } from '../../lib/couleurs'

// Couleurs officielles Manrina
const MANRINA_COLORS = {
  orange: 'rgb(var(--c-primary))',
  vert: 'rgb(var(--c-green))',
  creme: 'rgb(var(--c-creme))',
}

// Ecran de succes apres connexion
export default function ConnexionSuccess({ t }) {
  const { isWeb3 } = useTheme()
  return (
    <div className={`min-h-screen ${isWeb3 ? 'portal-bg' : 'portal-bg-web2'}`}>
      {isWeb3 ? (
        <>
          <div className="portal-bg-gradient" />
          <div className="portal-grid" />
        </>
      ) : (
        <>
          <div className="portal-bg-gradient-web2" />
          <StarParticles />
        </>
      )}
      <div className="min-h-screen flex items-center justify-center px-4 relative z-10">
        <div className="text-center">
          <div
            className={`w-24 h-24 mx-auto mb-6 rounded-full flex items-center justify-center ${
              isWeb3 ? 'bg-ink/30 border border-ink/50' : 'bg-ink/10'
            }`}
            style={{ boxShadow: `0 0 40px ${avecAlpha(MANRINA_COLORS.vert, 0.25)}` }}
          >
            <svg className="w-12 h-12" style={{ color: MANRINA_COLORS.vert }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2
            className={`text-2xl font-bold mb-2 ${t.textPrimary}`}
            style={{
              backgroundImage: isWeb3 ? `linear-gradient(to right, white, ${MANRINA_COLORS.orange})` : 'none',
              backgroundClip: isWeb3 ? 'text' : 'unset',
              WebkitBackgroundClip: isWeb3 ? 'text' : 'unset',
              color: isWeb3 ? 'transparent' : MANRINA_COLORS.vert,
            }}
          >
            Bienvenue !
          </h2>
          <p className={t.textSecondary}>Redirection en cours...</p>
        </div>
      </div>
    </div>
  )
}
